import { Component } from '@angular/core';
import { ActivityStatsComponent } from './activity-stats.component';

@Component({
  selector: 'eid-activity-stats-mobile',
  templateUrl: './activity-stats.mobile.component.html',
  styleUrls: ['./activity-stats.mobile.component.scss']
})
export class ActivityStatsMobileComponent extends ActivityStatsComponent {}
